// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"iq","cusMtdicon":"iq"};